module.exports = __webpack_public_path__ + "static/img/logo_anime_small.0f7bf48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_anime_small.jpg
// module id = vPp9
// module chunks = 0